import React from 'react'
import cx from 'classnames'
import { useMemo } from 'sb-hooks'

import s from './ProgressBar.scss'


type ProgressBarProps = {
  className?: string
  progress: number
}


const ProgressBar: React.FunctionComponent<ProgressBarProps> = ({ className, progress }) => {
  const barStyle = useMemo(() => ({
    width: `${Math.max(0, Math.min(100, progress))}%`,
  }), [ progress ])

  return (
    <div className={cx(className, s.container)}>
      <div className={s.bar} style={barStyle} />
    </div>
  )
}


export default ProgressBar
